module.exports = __webpack_public_path__ + "static/11-5db5fcfc66ed4b81d9b1b8b12f177255.png";